import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import CopyableValue from "./CopyableValue";
import {
  getFraudAlertSeverityChipColor,
  getFraudAlertSeverityLabel,
  getFraudAlertStatusLabel,
  getFraudAlertTypeLabel,
} from "../constants/operationalEnums";

const Field = ({ label, value, copyable = false }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    {copyable ? (
      <CopyableValue value={value} monospace />
    ) : (
      <Typography variant="body2" sx={{ mb: 1.5, wordBreak: "break-all" }}>
        {value ?? "—"}
      </Typography>
    )}
  </Grid>
);

const formatDate = (value) =>
  value ? new Date(value).toLocaleString("fa-IR") : "—";

const parseDetailsJson = (value) => {
  if (!value) return null;
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

const FraudAlertDetailDialog = ({ open, onClose, data, partnerLabel }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>جزئیات هشدار ضدتقلب #{data?.id ?? ""}</DialogTitle>
    <DialogContent dividers>
      {data ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary">
              نوع / شدت / وضعیت
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1.5 }}>
              <Chip size="small" label={getFraudAlertTypeLabel(data.alertType)} />
              <Chip
                size="small"
                color={getFraudAlertSeverityChipColor(data.alertType)}
                label={getFraudAlertSeverityLabel(data.alertType)}
              />
              <Chip size="small" label={getFraudAlertStatusLabel(data.status)} />
            </Box>
          </Grid>
          <Field label="نماینده" value={partnerLabel || data.partnerId} />
          <Field label="کاربر مرتبط" value={data.relatedUserId} />
          <Field label="موجودیت مرتبط" value={data.relatedEntityId} />
          <Field label="IP" value={data.ipAddress} copyable />
          <Field label="شناسه بازدیدکننده" value={data.visitorId} copyable />
          <Field label="User Agent" value={data.userAgent} />
          <Field label="توضیحات" value={data.description} />
          <Field label="تاریخ ایجاد" value={formatDate(data.detectedAt)} />
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary">
              جزئیات JSON
            </Typography>
            <Typography
              component="pre"
              variant="body2"
              sx={{
                mb: 1.5,
                p: 1.5,
                bgcolor: "grey.50",
                borderRadius: 1,
                overflow: "auto",
                maxHeight: 240,
                fontFamily: "monospace",
                fontSize: 12,
              }}
            >
              {parseDetailsJson(data.detailsJson) || "—"}
            </Typography>
          </Grid>
        </Grid>
      ) : null}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>بستن</Button>
    </DialogActions>
  </Dialog>
);

export default FraudAlertDetailDialog;
